export default __webpack_public_path__ + "static/cd-54a547f13ad617d3691fbe7c3e159cfaaf18cb7581e822811d2e5ac6081b2544.svg";